import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery, TeacherAdminDto, TeacherScheduleDto } from "../../interfaces";
import { RoleEnum } from "../../enums";
import { SelectListDto } from "../../models";

export const teacherAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTeacherAdminUsers: builder.query<
      any,
      { role: RoleEnum; data: PaginateQuery }
    >({
      query: ({ data }) => ({
        url: buildPaginationQueryString(data, `/api/user/teacher-admin`),
      }),
      providesTags: ["Paginated-Teacher-Admins"],
    }),
    getTeacherAdminUser: builder.query<TeacherAdminDto, string>({
      query: (id) => ({
        url: `/api/user/teacher-admin/${id}`,
      }),
      providesTags: ["TeacherAdmin"],
    }),
    addTeacherAdminUser: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/teacher-admin",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Teacher-Admins"],
    }),
    updateTeacherAdminUser: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/user/teacher-admin/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Teacher-Admins", "TeacherAdmin"],
    }),
    deleteTeacherAdminUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Teacher-Admins"],
    }),
    updateTeacherAdminUserProfit: builder.mutation<
      any,
      { id: string; data: any }
    >({
      query: ({ id, data }) => ({
        url: `/api/user/teacher-admin/${id}/profit`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Teacher-Admins"],
    }),
    getTeacherAdminSelectList: builder.query<
      SelectListDto[],
      string | undefined
    >({
      query: (subjectId) => ({
        url: subjectId
          ? `/api/user/teacher-admin/select-list?subjectId=${subjectId}`
          : `/api/user/teacher-admin/select-list`,
      }),
      providesTags: ["TeacherAdmin"],
    }),
    getTeacherSchedule: builder.query<TeacherScheduleDto, void>({
      query: () => ({
        url: "/api/user/teacher-admin/schedule",
      }),
      providesTags: ["TeacherSchedule"],
    }),
    updateTeacherSchedule: builder.mutation<
      TeacherScheduleDto,
      { schedule: TeacherScheduleDto["schedule"] }
    >({
      query: (data) => ({
        url: "/api/user/teacher-admin/schedule",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["TeacherSchedule"],
    }),
  }),
});

export const {
  useGetTeacherAdminUsersQuery,
  useGetTeacherAdminUserQuery,
  useAddTeacherAdminUserMutation,
  useUpdateTeacherAdminUserMutation,
  useDeleteTeacherAdminUserMutation,
  useUpdateTeacherAdminUserProfitMutation,
  useGetTeacherAdminSelectListQuery,
  useGetTeacherScheduleQuery,
  useUpdateTeacherScheduleMutation,
} = teacherAdminApi;
